// import { Box } from '@mui/material'; // Citations temporarily hidden
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatMessage as APIChatMessage, ChatSource } from '../../api/data-contracts';
import { JsonValue } from '../../types/common';
// import { Sources } from './Sources'; // Citations temporarily hidden
import { MarkdownMessage } from './MarkdownMessage';
import { MessageContainer } from './MessageContainer';
import { log } from '../../utils/errors/logger';

interface ChatMessage extends APIChatMessage {
  sources?: ChatSource[];
}

interface ChatMessageProps {
  message: ChatMessage;
  isUser: boolean;
}

export const ChatMessageComponent: React.FC<ChatMessageProps> = ({ message, isUser }) => {
  useTranslation(); // Keep for future use
  
  // Use exclusively the local sources of this message
  const messageSources: ChatSource[] = !isUser && message.sources ? [...message.sources] : [];
  
  // Debug output for sources
  if (!isUser && messageSources.length > 0) {
    log.info(`Rendering message with ${messageSources.length} sources:`, {
      messagePreview: `${message.content.substring(0, 30)  }...`,
      sources: messageSources as unknown as JsonValue
    });
  }

  return (
    <>
      <MessageContainer isUser={isUser}>
        <MarkdownMessage content={message.content} isUser={isUser} />
      </MessageContainer>
      
      {/* Display sources if available and it's an assistant message */}
      {/* Citations temporarily hidden
      {!isUser && messageSources.length > 0 && (
        <Box sx={{ pl: 2, pt: 1, maxWidth: '80%' }}>
          <Sources sources={messageSources} />
        </Box>
      )}
      */}
    </>
  );
};